import { SpaceProvider } from '@ably/spaces/dist/mjs/react/contexts/SpaceContext';

import ChannelProvider from '@/channels/ChannelProvider';
import { billingItemsChannelName } from '@/channels/utils/channelNames';

import BillingItemsList from './BillingItemsList';

const BillingItemsListApp = () => {
  return (
    <ChannelProvider channelName={billingItemsChannelName()}>
      <SpaceProvider name="billing-items-space">
        <BillingItemsList />
      </SpaceProvider>
    </ChannelProvider>
  );
};

export default BillingItemsListApp;
